import React from 'react';
import ccTeaser from '../../../images/corrcluster/corrcluster_teaser.png';
import { TEASER_EMAIL_CATALYST } from '../../../actions/urlTypes';
import { CAC_TEASER_MESSAGE, CAC_TEASER_TITLE } from '../CacConstants';

const CorrClusterTeaser = () => {
  return (
    <div>
      <div className="corrclust-width-455 minimize-tp float-left">
        <ul className="tool_bg" />
      </div>
      <div
        style={{
          overflowY: 'auto',
          height: 'calc(100vh - 57px)',
          overflowX: 'hidden',
        }}
      >
        <div className="corrclust-teaser-panel">
          <div className="heading1">{ CAC_TEASER_TITLE }</div>
          <div className="heading3">
            <p>{CAC_TEASER_MESSAGE}</p>
          </div>
          <div className="heading2">
            Contact your representative or{' '}
            <u>
              <a href={`mailto:${TEASER_EMAIL_CATALYST}`}>
                {TEASER_EMAIL_CATALYST}
              </a>
            </u>{' '}
            for more information
          </div>
          {/* className="heading-img"  */}
          <div className="heading4">
            <div>
              <img
                className="heading-img"
                src={ccTeaser}
                alt="Correspondence and Cluster Analysis"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CorrClusterTeaser;
